import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import { Flex, Text, Box, Image } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import "../Assets/css/font.css";
import SideImageTag from "../Assets/Images/side-tag.svg";

function base64ToBlob(base64, mime) {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mime });
}

function base64ToImageURL(dataURL) {
  const [metadata, base64] = dataURL.split(",");
  const mime = metadata.match(/data:([^;]+);base64/)[1];
  const blob = base64ToBlob(base64, mime);
  return URL.createObjectURL(blob);
}

// function splitIntoChunks(text, chunkSize) {
//   const words = text.split(" ");
//   const chunks = [];
//   for (let i = 0; i < words.length; i += chunkSize) {
//     chunks.push(words.slice(i, i + chunkSize).join(" "));
//   }
//   return chunks;
// }

const GetEventTag = () => {
  const getEventTagData = useSelector((state) => state?.events?.getTagDetails);
  const tagData = [
    { title: "Event Name", description: getEventTagData?.eventName },
    { title: "Attendance Type", description: getEventTagData?.attendanceType },
    {
      title: "Start Date",
      description:
        getEventTagData?.eventStartDate &&
        format(new Date(getEventTagData?.eventStartDate), "yyyy-MM-dd"),
    },
    {
      title: "End Date",
      description:
        getEventTagData?.eventEndDate &&
        format(new Date(getEventTagData?.eventEndDate), "yyyy-MM-dd"),
    },
  ];

  const [qrCodeUrl, setQrCodeUrl] = useState("");
  console.log(qrCodeUrl)

  useEffect(() => {
    if (getEventTagData?.qrCodeImage) {
      const url = base64ToImageURL(getEventTagData?.qrCodeImage);
      setQrCodeUrl(url);
      return () => URL.revokeObjectURL(url);
    }
  }, [getEventTagData?.qrCodeImage]);

  const handlePrintTag = () => {
    window.print();
  };

  return (
    <Box className="tagBg" id="printable-tag" display="flex" justifyContent="">
      <style>
        {`
        @page {
          size: 150mm 500mm;
        }
        @media print {
          @page {
            size: a6 portrait;
            margin: 0mm !important;
          }
          #printable-tag {
            -webkit-print-color-adjust: exact;
            color-adjust: exact;
          }
          #no-print, .modal-close-button {
            display: none;
          }
          #no-printContainer {
            justify-content: end;
            margin-top: 60px
          }
        }
      `}
      </style>

      <Image mr={2} src={SideImageTag} alt="Side Decoration" />
      

      <Box>
        <Flex justify="flex-end" mb="">
          <Image
            src={getEventTagData?.logoUrl}
            alt="Logo"
            width="81px"
            height="34px"
            mt={2}
            mr={4}
          />
        </Flex>

        {/* {getEventTagData?.signatureUrl ? (
          <Image
            src={getEventTagData?.signatureUrl}
            alt="Smart Eco Logo"
            width={"250px"}
            // height={"49px"}
            mt={8}
            color={"#FFFFFF"}
            fontSize={"18px"}
            lineHeight={"14.06px"}
            position={"absolute"}
            opacity={0.1}
            top={"50%"}
          />
        ) : null}
      
       <Image
          src={getEventTagData?.smartEcoLogo}
          alt="Smart Eco Logo"
          width={"158px"}
          height={"49px"}
          mt={8}
          color={"#FFFFFF"}
          fontSize={"18px"}
          lineHeight={"14.06px"}
        />  */}

        <Flex justifyContent="center" mt={4} mb={4}>
          <Image
            src={getEventTagData?.passportUrl}
            alt="Profile Pic"
            rounded="full"
            width={["160px", "180px", "180px"]}
            height={["160px", "180px", "180px"]}
            objectFit="cover"
            border="8px solid #FFFFFF"
          />
        </Flex>

        {/* Full Name */}
        <Text
          textAlign="center"
          mt={4}
          mb={6}
          color="#17191C"
          fontSize="24px"
          lineHeight="25px"
        >
          {getEventTagData?.fullName}
        </Text>

        {/* Event Details */}
        {tagData?.map((data, index) => (
          <Box key={index} w="100%" px={4} mb={2}>
            <Flex justifyContent="flex-start" alignItems="flex-start" py={1}>
              <Text
                fontSize="13px"
                lineHeight="105%"
                color="#121212CC"
                opacity="80%"
                minWidth="80px"
                mr={1}
              >
                {data?.title}:
              </Text>

              <Text
                fontSize="14px"
                lineHeight="100%"
                color="#121212"
                fontWeight="bold"
                opacity="80%"
              >
                {data?.description}
              </Text>
            </Flex>
            <Box borderBottom="1px solid #C6D1CB" mt={1} />
          </Box>
        ))}

        {/* QR and Print */}
        <Flex
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          gap="100px"
          id="no-printContainer"
        >
          <Text
            mt={"50px"}
            textDecoration={"underline"}
            color={"#22944E"}
            fontSize={"14px"}
            cursor={"pointer"}
            id="no-print"
            onClick={handlePrintTag}
          >
            Print Tag
          </Text>

          <Image mr={4} mt={50} src={qrCodeUrl} alt="QR Code" width={"80px"} height={"80px"} />
        </Flex>
      </Box>
    </Box>
  );
};

export default GetEventTag;
